/**
 * Unit count economy: apply deltas with soft/hard caps and power tokens.
 */
import { DISPLAY_EXACT_MAX, HARD_CAP, SOFT_CAP } from "./constants.js";
export function createCountState(startN) {
    return clampCount({ n: Math.max(0, Math.floor(startN)), powerTokens: 0 });
}
/**
 * Clamp N into [0, HARD_CAP]; overflow increments power tokens.
 * Soft cap is a readability hint only (no automatic conversion).
 */
export function clampCount(state) {
    let n = Math.max(0, Math.floor(state.n));
    let powerTokens = Math.max(0, Math.floor(state.powerTokens));
    if (n > HARD_CAP) {
        powerTokens += n - HARD_CAP;
        n = HARD_CAP;
    }
    return { n, powerTokens };
}
/** Set absolute count (e.g. after gate), preserving tokens and re-clamping. */
export function setCount(state, n) {
    return clampCount({ n, powerTokens: state.powerTokens });
}
/** Add delta to N (can be negative). */
export function addCount(state, delta) {
    return setCount(state, state.n + delta);
}
export function isSoftCapped(n) {
    return n >= SOFT_CAP;
}
export function isHardCapped(n) {
    return n >= HARD_CAP;
}
/**
 * Display string: exact through DISPLAY_EXACT_MAX, then compact (e.g. 120 → "120", 1000 → "1.0k").
 * GDD: exact to 99; then compact — we keep integers readable until 999 for UI clarity.
 */
export function formatCountDisplay(n) {
    const v = Math.max(0, Math.floor(n));
    if (v <= DISPLAY_EXACT_MAX)
        return String(v);
    if (v < 1000)
        return String(v);
    if (v < 10_000)
        return `${(v / 1000).toFixed(1)}k`;
    return `${Math.floor(v / 1000)}k`;
}
export { SOFT_CAP, HARD_CAP, DISPLAY_EXACT_MAX };
//# sourceMappingURL=count.js.map